<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>店铺列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-input size="small" v-model="formInline.account" placeholder="输入用户地址"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column  align="center" prop="shopName" label="店铺名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  align="center" prop="shopId" label="店铺号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  align="center" prop="userAddress" label="用户地址" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="cursor: pointer;" @click="copyAddress(scope.row.userAddress)">{{ scope.row.userAddress | plusXing2}}</div>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="shopPhoto" label="店铺图标" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.shopPhoto != null"
            :src="scope.row.shopPhoto"
            :preview-src-list="picList"
            style="width: 100px;height: 100px;"
          />
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="shopType" label="店铺类型" width="130" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.shopType == 0?'算力店铺':scope.row.shopType == 1?'普通店铺':'本地生活' }}</span>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="logTime" label="注册时间" width="130" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.logTime | timeStamp}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.status == 1" @click="handleEdit(0, scope.row)">解封</el-button>
          <el-button size="mini" v-else type="danger" @click="handleEdit(1, scope.row)">封禁</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    
  </div>
</template>

<script>
import { getAllShop, exShop } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        account: ''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      picList: [],
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  filters: {
    filterData(val) {
        let newVal = JSON.parse(val);
        return newVal[0]
    },
    plusXing2(str) {
      if (str.length == 0) {
        return "";
      }
      var len = str.length - 4;
      var xing = '';
      for (var i = 0; i < 5; i++) {
        xing += '*';
      }
      return str.substring(0, 6) + xing + str.substring(str.length - 4);
    },
    timeStamp: function(val) {
      let value = val * 1000;
      var date = new Date();
      date.setTime(value);
      var month = date.getMonth() + 1;
      var hours = date.getHours();
      if (hours < 10)
        hours = "0" + hours;
      var minutes = date.getMinutes();
      if (minutes < 10)
        minutes = "0" + minutes;
      var time = month + "-" + date.getDate() +
        " " + hours + ":" + minutes;
      return time;
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    clickType(e) {
      this.formInline.goodType = e;
      this.getdata(this.formInline);
    },
    copyAddress(val) {
      this.$copyText(val.replace(/( |null)/g, '')).then(
        (e) => {
          this.$message.success('复制成功!')
          console.log(e);
        },
        (err) => {
          this.$message.error('复制失败,请重试!')
          console.log(err);
        }
      );
    },
    getdata(parameter) {
      this.loading = true
      getAllShop(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            this.listData.forEach((item) => {
              this.picList.push(item.userCard1);
            });
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.num
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(val, row) {
        this.$confirm('确定要操作吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            exShop({shopId: row.id,del:val})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/system/shop.vue